module.exports = __webpack_public_path__ + "static/media/wake-up-host.748bc216.gif";